import { CasinoGamesLoadMoreBtnType } from '../providers/CasinoGamesConfigsContext';

export const CasinoGamesDefaultConstants = {
  LOAD_MORE_TYPE: CasinoGamesLoadMoreBtnType.BUTTON,
  GAMES_PER_ROW: 6,
  GAMES_ROWS: 1,
  CASINO_GAMES_LIMIT: 16,
  LOAD_MORE_BUTTON_ENABLED: false,
  ARROWS_ENABLED: false,
  CATEGORY_NAME_VISIBLE: false
};
